/**
 * French locale. Keys must mirror en.ts exactly. Terminology follows the
 * FFN French edition of the World Aquatics Diving Rules and Plongeon usage:
 * plongeon/saut périlleux, carpé/groupé/droit/libre,-renversé/retourné,
 * vrille, tremplin, plateforme.
 */
const fr = {
  // Library UX fixes (périmètre A, bloc dédié) : clés introduites par la PR
  // de corrections Library (état, recherche par nom, pagination, période).
  libraryUX: {
    periodFilter: 'Période',
    periodAll: 'Toutes les périodes',
    period30d: '30 derniers jours',
    period90d: '3 derniers mois',
    period180d: '6 derniers mois',
    period365d: 'An dernier',
    showMoreAttempts_one: 'Afficher {{count}} plongeon de plus',
    showMoreAttempts_other: 'Afficher {{count}} plongeons de plus',
    loadMoreSessions: 'Charger plus de séances',
    sessionBadge: 'Séance',
    sessionVideos_one: '{{count}} vidéo',
    sessionVideos_other: '{{count}} vidéos',
    sessionRowAria_one: 'Séance · {{count}} vidéo',
    sessionRowAria_other: 'Séance · {{count}} vidéos',
  },
  room: {"soundOn": 'Activer le son',"next": "Suivant","toResults": "Voir les résultats","waiting": "En attente des autres…","joinCode": "Code de la salle","joinGo": "Rejoindre","shadow": "Mon fantôme","playerCount_one": "{{count}} joueur", "playerCount_other": "{{count}} joueurs", "ghostCount_one": "{{count}} fantôme", "ghostCount_other": "{{count}} fantômes", "diveCount_one": "{{count}} plongeon", "diveCount_other": "{{count}} plongeons","guessCode": 'Devine le code',"harsh": 'Le plus sévère',"shadowOptIn": 'Autoriser mon fantôme',"title": "Salle de jury", "create": "Créer une salle", "room": "Salle {{code}}", "invite": "{{name}} vous invite à juger", "nickname": "Votre pseudo", "join": "Rejoindre la salle", "account": "J’ai déjà un compte", "error": "Connexion ou action impossible. Réessayez.", "copy": "Copier", "copied": "Copié", "jury": "Jury", "host": "hôte", "ghost": "fantôme", "player": "joueur", "mode": "Mode", "classic": "Classique", "mole": "🕵️ La taupe", "dives": "Plongeons", "latest": "Ma dernière séance", "community": "Communauté", "code": "Par code", "apply": "Choisir", "empty": "Aucun plongeon public prêt à lire.", "start": "Lancer", "secret": "🕵️ Vous êtes la taupe. Poussez les notes sans vous faire repérer.", "submitted": "Note envoyée", "submit": "Valider", "high": "HAUTE", "low": "BASSE", "juryScore": "Note du jury", "yourScore": "Votre note", "points": "Points", "roast": "🌶️ Le jury a tranché.", "findMole": "Y a-t-il une taupe ?", "nobody": "Personne", "vote": "Voter", "finished": "Partie terminée", "moleWas": "La taupe : {{name}}", "sharp": "Œil de lynx", "streak": "Série", "challenge": "Défier d’autres amis", "replay": "Rejouer", "line": {"shadow": 'Je garde un œil sur l’entrée.',"mum": "Il fait tellement d’efforts.", "coach": "Éclaboussure. Encore.", "copy": "Je prends des notes.", "olympian": "Presque comme aux Jeux."}},
  series: { mySeries: "Mes séries" },
  messages: {"title": "Messages", "message": "Message", "new": "Nouveau message", "recipient": "Choisir un membre", "inbox": "Boîte de réception", "empty": "Aucune conversation.", "choose": "Choisissez une conversation ou commencez-en une.", "conversation": "Conversation", "begin": "Commencez la conversation.", "older": "Messages précédents", "more": "Autres conversations", "compose": "Votre message", "placeholder": "Écrivez un message… Utilisez @ pour mentionner un membre.", "send": "Envoyer", "sent": "Envoyé", "delivered": "Distribué", "readAt": "Lu le {{time}}", "react": "Réagir avec un cœur", "reactionHint": "Touchez deux fois un message pour réagir. Au clavier, utilisez le bouton cœur.", "yourMessage": "Votre message", "receivedMessage": "Message reçu", "watch": "Voir le plongeon", "diveCard": "Plongeon", "diveUnavailable": "Ce plongeon n’est plus disponible pour vous.", "sendDive": "Envoyer le plongeon en message", "diveSent": "Plongeon envoyé.", "open": "Ouvrir la conversation", "sendDiveError": "Envoi impossible. Le plongeon doit être accessible aux deux membres. Réessayez.", "error": "Messages indisponibles. Réessayez.", "newShort": "Nouveau", "placeholderShort": "Message…", "you": "Vous :", "today": "Aujourd’hui", "yesterday": "Hier", "readShort": "Lu à {{time}}", "unread_one": "{{count}} message non lu", "unread_other": "{{count}} messages non lus", "newGroup": "Nouveau groupe", "createGroup": "Créer le groupe · {{count}} personnes", "pickTwo": "Choisissez au moins 2 personnes", "groupFull": "Les groupes sont limités à {{count}} personnes", "removeMember": "Retirer {{name}}", "members_one": "{{count}} membre", "members_other": "{{count}} membres", "groupOptions": "Options du groupe", "leave": "Quitter le groupe", "leaveConfirm": "Quitter ce groupe ? Vous ne recevrez plus ses messages.", "readBy_one": "Lu par {{count}}", "readBy_other": "Lu par {{count}}", "formerMember": "Ancien membre", "create": "Créer", "groupName": "Nom du groupe", "groupNamePlaceholder": "Nom du groupe (facultatif)", "saveName": "Enregistrer le nom", "notificationDesc": "Alertes de messages privés"},
    mentions: { choose: 'Mentionner un membre', loading: 'Recherche de membres…', empty: 'Aucun membre trouvé', error: 'Impossible de rechercher les membres.' },
  common: {
    loading: 'Chargement…',
    loadingPage: 'Chargement de la page…',
    optional: 'facultatif',
    characters: 'caractères',
    close: 'Fermer',
    back: 'Retour',
    save: 'Enregistrer',
    cancel: 'Annuler',
    error: 'Erreur',
    retry: 'Réessayer',
  },
  journey: {
    title: 'Votre parcours de plongeon',
    errorLoad: 'Échec du chargement de votre parcours',
    uniqueDives: 'Plongeons uniques',
    trainingDays: 'Jours d’entraînement',
    improvement: 'Progression',
    trajectory: 'Trajectoire',
    sectionsAria: 'Sections du parcours',
    section: 'Section du parcours',
    yourStory: 'Votre histoire',
    ddProgression: 'Progression de cotation',
    milestones: 'Étapes marquantes',
    phaseAnalysis: 'Analyse par phase',
    psychology: 'Psychologie',
    patterns: 'Schémas',
    show: 'Afficher',
    all1plus: 'Toutes (1+)',
    only5: '5 seulement',
    twoPhaseAnalysis: 'Analyse du plongeon en deux phases',
    twoPhaseFormat: 'Format en deux phases',
    legacyFormat: 'Format ancien',
    newFormatPct: '% nouveau format',
    phase1Title: 'Phase 1 : impulsion + vol (départ)',
    phase2Title: 'Phase 2 : ouverture + entrée (réception)',
    averageScore: 'Score moyen',
    commonCombinations: 'Combinaisons de phases les plus fréquentes',
    coachingInsights: 'Conseils d’entraînement',
    mentalBlockStatus: 'État des blocages mentaux',
    psychologicalProfile: 'Profil psychologique',
    mentalBlocksDetected: 'Blocages mentaux détectés',
    fearVsDifficulty: 'Peur vs cotation',
    confidenceTrend: 'Tendance de confiance',
    stable: 'Stable',
    mentalBlockDetected: 'Blocage mental détecté',
    mentalBlockDetail: 'Même cotation maximale depuis 3 mois ou plus.',
    growth: 'Progrès',
    firstMonthAvg: 'Performance moyenne du premier mois',
    latestMonthAvg: 'Performance moyenne du dernier mois',
    overallImprovement: 'Progression globale',
    noPsychology: 'Aucune donnée de psychologie.',
    performanceProgression: 'Progression de la performance',
    totalImprovement: 'Progression totale',
    timeline: 'Chronologie',
    trainingSpan: 'Durée d’entraînement',
    days: 'jours',
    started: 'Début',
    latest: 'Dernier',
    differentDives: 'plongeons différents',
  },
  milestones: {
    labels: {
      first_attempt: 'Premier essai',
      first_success: 'Première réussite',
      first_good: 'Premier « bon »',
      first_perfect: 'Premier parfait',
      first_from_height: 'Premier plongeon depuis une hauteur',
      breakthrough: 'Percée',
      redemption: 'Rédemption',
      comeback: 'Retour',
      avoided_dive_attempted: 'Affronter la peur',
      success_streak: 'Série de réussites',
      perfect_streak: 'Série de parfaits',
      consistency_achieved: 'Régularité',
      plateau_broken: 'Plateau franchi',
      new_height_conquered: 'Nouvelle hauteur domptée',
      training_streak: 'Série d’entraînement',
      synchro_first_success: 'Première réussite en synchro',
      personal_best: 'Record personnel',
    },
    historyAria: 'Historique des étapes marquantes',
    noMatches: 'Aucune étape marquante ne correspond à ce filtre.',
    count: 'étapes marquantes',
    majorNotable: '{{count}} majeure ou notable',
    majorBreakthrough: 'Percée majeure',
    notableStep: 'Étape notable',
    meaningfulProgress: 'Progrès révélateur',
    recordedProgress: 'Progrès enregistré',
    review: 'Revoir',
    dismiss: 'Fermer l’étape marquante',
    afterFailures: 'Elle est venue après {{count}} essais précédents. La persévérance a payé.',
    firstTryPerfect: 'Parfait du premier essai !',
    masteryAfter: 'Après {{count}} essais, la maîtrise.',
    sameDay: 'Le même jour.',
    daysLater: '{{count}} jours plus tard.',
    first_attempt: { title: 'Premier {{code}} depuis {{height}}', narrative: 'Vous avez tenté {{codeLabel}} depuis {{height}} pour la première fois. Chaque expert fut un jour un débutant.' },
    first_success: { title: 'Premier {{code}} réussi', narrative: 'Votre premier {{codeLabel}} réussi depuis {{height}} !' },
    first_good: { title: 'Premier « bon » sur {{code}}', narrative: 'Première performance « bonne » sur {{codeLabel}} depuis {{height}}.' },
    first_perfect: { title: 'Premier {{code}} parfait', narrative: 'Exécution parfaite de {{codeLabel}} depuis {{height}}.' },
    first_from_height: { title: 'Premier plongeon depuis {{height}}', narrative: 'Vous avez plongé depuis {{height}} pour la première fois.' },
    breakthrough: { title: 'Percée sur {{code}}', narrative: 'Vous avez réussi {{codeLabel}} après {{failures}} échecs consécutifs. Voilà à quoi ressemble la progression.' },
    redemption: { title: 'Rédemption : {{code}} parfait', narrative: 'De la giclée à la perfection.' },
    comeback: { title: 'Retour : {{code}}', narrative: 'Vous êtes revenu sur {{codeLabel}} après {{days}} jours d’absence.' },
    avoided_dive_attempted: { title: 'Affronter la peur : {{code}}', narrative: 'Après {{days}} jours, vous avez affronté à nouveau {{codeLabel}}, un plongeon qui vous avait donné du fil à retordre.' },
    success_streak: { title: 'Série de {{streak}} réussites', narrative: '{{streak}} {{codeLabel}} réussis d’affilée depuis {{height}}.' },
    perfect_streak: { title: 'Série de {{streak}} parfaits', narrative: '{{streak}} exécutions parfaites consécutives de {{codeLabel}}.' },
    consistency_achieved: { title: 'Régularité au rendez-vous : {{code}}', narrative: 'Vos 10 derniers {{codeLabel}} depuis {{height}} montrent une régularité remarquable. Ce plongeon est prêt pour la compétition.' },
    plateau_broken: { title: 'Plateau franchi', narrative: 'Après des mois de performance stable, vous avez percé.' },
    new_height_conquered: { title: 'Nouvelle hauteur domptée : {{height}}', narrative: 'Vous avez dompté {{height}}.' },
    training_streak: { title: '{{streak}} jours d’affilée', narrative: '{{streak}} jours consécutifs d’entraînement.' },
    synchro_first_success: { title: 'Premier plongeon en synchro réussi', narrative: 'Votre premier plongeon synchronisé réussi.' },
    personal_best: { title: 'Record personnel : {{code}}', narrative: 'Nouveau record personnel sur {{codeLabel}} depuis {{height}}.' },
  },
  clipViewer: {
    diveReview: 'RÉVISION DE PLONGEON',
    noLinkedClip: 'Aucun extrait lié à ce plongeon.',
    likeDive: 'Aimer le plongeon',
    like: 'J’aime',
  comments: 'Commentaires',
    analysis: 'Analyse',
    private: 'Privé',
    public: 'Public',
    defaultCaption: 'Chaque plongeon, un peu plus loin.',
    details: 'Détails',
    closeDetailsAndComments: 'Fermer les détails et les commentaires',
    diveDetails: 'Détails du plongeon',
    discussion: 'DISCUSSION',
    theAttempt: 'LE PLONGEON',
    closePanel: 'Fermer le panneau',
    description: 'DESCRIPTION',
    noDescription: 'Aucune description pour ce plongeon.',
    privateDive: 'Plongeon privé',
    publicDive: 'Plongeon public',
    manageDive: 'Gérer le plongeon',
    playPause: 'Lire ou mettre en pause',
    prevAttempt: 'Plongeon précédent',
    nextAttempt: 'Plongeon suivant',
    play: 'Lire la vidéo',
    pause: 'Mettre en pause',
    resume: 'Reprendre la lecture',
    unmute: 'Réactiver le son',
    mute: 'Couper le son',
    videoPosition: 'Position de la vidéo',
    shareDive: 'Partager le plongeon',
    copyLinkToShare: 'Copiez ce lien pour partager la vidéo :',
    shareLink: 'Lien de partage',
    visibility: 'Visibilité du plongeon',
    visibilityHint: 'Public : plongeurs connectés. Privé : seulement vous.',
    linkCopied: 'Lien copié',
    linksRevoked: 'Liens partagés révoqués',
    createLinkError: 'Impossible de créer un lien. Réessayez.',
    revokeError: 'Impossible de révoquer les liens. Réessayez.',
    sharing: 'Partage…',
    share: 'Partager',
    videoSharing: 'Partage de la vidéo',
    shareVideo: 'Partager la vidéo',
    dismissSharing: 'Fermer la notification de partage',
    copyLink: 'Copier le lien',
    shareChoose: 'Choisissez comment partager ce plongeon.',
    shareLinkHint: 'Partager en dehors de l’application',
    shareDm: 'Envoyer en message privé',
    shareDmHint: 'Choisissez à qui envoyer ce clip.',
    revokeLinks: 'Révoquer les liens partagés',
    couldNotSave: 'Impossible d’enregistrer.',
    tabEvaluation: 'Évaluation',
    toRate: 'à noter',
    sameDay: 'Plongeons du même jour',
    openFromStrip: 'Ouvrir {{code}}, note {{score}}',
  },
  clipEvaluation: {
    yourScore: 'Votre note',
    ownerTitle: 'Notes reçues',
    circuitRequest: 'Évaluation demandée',
    circuitCommunity: 'Note communautaire · provisoire',
    prompt: 'Consigne du plongeur :',
    commentPlaceholder: 'Commentaire pour le plongeur (facultatif)',
    confirm: 'Confirmer ma note',
    confirmScore: 'Confirmer {{score}}',
    once: 'Une seule note par plongeon. Les notes des autres juges apparaissent après la vôtre.',
    submitError: 'Impossible d’enregistrer votre note. Réessayez.',
    loadError: 'Impossible de charger l’évaluation.',
    mean: 'moyenne · {{count}} juge(s)',
    juryAria: 'Notes du jury',
    noVotes: 'Aucune note pour l’instant. Le {{score}} affiché est la note de performance enregistrée, pas une note de jury.',
    closed: 'Ce plongeon n’est pas ouvert aux notes.',
    ownerPrivate: 'Ce plongeon est privé : demandez une évaluation pour recevoir des notes.',
    ownerCannotRate: 'Vous ne pouvez pas noter votre propre plongeon.',
    excluded: 'Exclu des sélections automatiques.',
  },
  comments: {
    viewProfileBy: 'Voir le profil de {author}',
    errorLoad: 'Impossible de charger les commentaires.',
    errorLoadReplies: 'Impossible de charger les réponses. Réessayez.',
    errorSaveReply: 'Impossible d’enregistrer la modification. Réessayez.',
    errorPost: 'Impossible de publier votre commentaire. Votre texte est conservé ici.',
    join: 'Rejoignez la discussion',
    placeholder: 'Ajouter un commentaire…',
    post: 'Publier le commentaire',
    loading: 'Chargement des commentaires…',
    noComments: 'Aucun commentaire pour l’instant.',
    beFirst: 'Soyez le premier à partager une idée sur ce plongeon.',
    replyPlaceholder: 'Écrire une réponse…',
    savingReplies: 'Enregistrement ou chargement des réponses…',
    olderReplies: 'Réponses antérieures',
    replyTo: 'Répondre à',
    postReplyTo: 'Publier une réponse à {{author}}',
    reply: 'Répondre',
    likeBy: 'Aimer le commentaire de {{author}}',
    deleteBy: 'Supprimer le commentaire de {{author}}',
    retryReplies: 'Réessayer les réponses',
    hideReplies: 'Masquer les réponses',
    viewReplies: 'Voir les réponses ({{count}})',
  },
  diveManagement: {
    title: 'Modifier le plongeon',
    saved: 'Plongeon enregistré.',
    errorSave: 'Impossible d’enregistrer le plongeon. Réessayez.',
    errorDelete: 'Impossible de supprimer le plongeon. Réessayez.',
    performance: 'Performance du plongeon',
    personalNotes: 'Notes personnelles',
    working: 'Traitement…',
    saveChanges: 'Enregistrer',
    delete: 'Supprimer le plongeon',
    deleteConfirm: 'Supprimer ce plongeon ? Impossible de revenir en arrière. La vidéo d’origine est conservée.',
    confirmDelete: 'Confirmer la suppression',
  },
  sync: {
    statusProgress: 'Synchro {{status}}',
    synced: 'Synchronisés',
    errors: 'Erreurs',
    duration: 'Durée',
    recentMilestones: 'Étapes marquantes récentes',
    started: 'Synchronisation démarrée',
    complete: 'Synchronisation terminée',
    error: 'Erreur de synchronisation',
    failed: 'Échec de la synchronisation',
    videosCount: '{{count}} vidéos',
    videosSynced: '{{count}} vidéos synchronisées',
    milestoneToast: 'Étape marquante',
    dismissNotification: 'Fermer la notification',
    syncId: 'ID de synchro',
    errorMessage: 'Message d’erreur',
    retryAttempts: 'Tentatives :',
    retry: 'Réessayer',
    dismiss: 'Ignorer',
    maxRetries: 'Nombre maximal de tentatives atteint.',
    unknownError: 'Une erreur inconnue est survenue',
    connected: 'Connecté',
    offline: 'Hors ligne',
    disconnected: 'Déconnecté',
    reconnecting: 'Reconnexion…',
    inProgress: 'Synchronisation en cours',
    idLabel: 'ID :',
    dismissError: 'Fermer l’erreur',
  },
  thumbnail: {
    posterFor: 'Affiche de {{code}}',
    ready: 'Vidéo prête',
    linked: 'Vidéo liée',
  },
  mediaStatus: {
    ready: 'prêt',
    partial: 'partiel',
    missing: 'manquant',
    failed: 'échec',
    unavailable: 'indisponible',
    queued: 'en file d’attente',
    waiting_for_mac: 'en attente du Mac',
    claimed: 'pris en charge',
    materializing: 'matérialisation',
    exporting: 'export en cours',
    transcoding: 'transcodage',
    uploading: 'envoi en cours',
    verifying: 'vérification',
    photos: { ok: 'ok', permission_required: 'autorisation requise', denied: 'refusé', unknown: 'inconnu' },
    not_cached: 'non mis en cache',
    replacement_available: 'remplacement disponible',
    replacement_exhausted: 'remplacement épuisé',
  },
  progress: {
    noRecentSessions: 'Aucune séance ces 7 derniers jours',
    showing: 'Affichage : {{range}}',
    mostRecentWeek: 'Semaine la plus récente',
    last7Days: '7 derniers jours',
    totalDives: 'Total de plongeons',
    vsPrev: 'vs préc.',
    vsPrevWeek: 'vs semaine préc.',
    avgPerformance: 'Performance moy. /10',
    calibratedScore: 'Score calibré',
    success: 'Réussite',
    latest: 'Dernier',
    sessions: 'Séances',
    recentSessions: 'Séances récentes',
    performance: 'Performance /10',
    successRate: 'Taux de réussite',
    divesCount: '{{count}} plongeons',
  },
  sharedDive: {
    eyebrow: 'PLONGEON PARTAGÉ',
    errorInvalid: 'Ce lien partagé est invalide ou n’est plus disponible.',
    errorUnavailable: 'Cette vidéo partagée est indisponible. Le lien a peut-être été révoqué.',
    like: 'J’aime',
    commentsLabel: 'Commentaires',
    videoAria: 'Vidéo partagée',
    videoUnavailable: 'Vidéo indisponible.',
    retryVideo: 'Réessayer la vidéo',
    discussionAria: 'Discussion des invités',
    commentingAs: 'Vous commentez en tant que',
    loadingShared: 'Chargement de la vidéo partagée…',
  },
  sessionVideo: {
    title: 'Vidéos de séance',
    empty: 'Aucune vidéo de séance pour l’instant.',
    loading: 'Chargement de la séance…',
    unavailable: 'Cette vidéo de séance est indisponible.',
    invalidLink: 'Ce lien de partage est invalide ou n’est plus disponible.',
    unplayable: 'Cette vidéo ne se lit pas ici',
    download: 'Télécharger · {{size}}',
    share: 'Partager la séance',
    videoAria: 'Vidéo de la séance',
  },
  repMedia: {
    viability: {
      ready: 'déjà prêt',
      previously_successful: 'déjà matérialisé',
      untested: 'non testé',
      retryable_failure: 'échec récupérable',
      known_placeholder_failure: 'échec sur espace réservé',
      permanently_unavailable: 'définitivement indisponible',
    },
    role: { low: 'Bas', median: 'Typique', high: 'Haut' },
    mediaVideoReady: 'Vidéo prête',
    mediaPosterOnly: 'Affiche prête · vidéo manquante',
    mediaUnavailable: 'Vidéo indisponible',
    mediaMissing: 'Média manquant',
    posterAlt: 'Affiche représentative {{code}} {{label}}',
    play: 'Lire',
    loadCandidatesError: 'Impossible de charger les candidats de remplacement.',
    summaryDiveCodes: 'Codes de plongeon',
    summaryRepresentatives: 'Représentants',
    summaryFullyReady: 'Codes entièrement prêts',
    summaryPartial: 'Codes partiels',
    summaryZeroReady: 'Codes sans média prêt',
    auditZeroReady: 'Audit des codes sans média prêt',
    auditPlaceholder: 'Échecs sur espace réservé',
    auditViable: 'Candidats viables sans média prêt',
    auditPhotos: 'Accès à Photos',
    photosUnknown: 'inconnu',
    filterDiveCode: 'Code de plongeon',
    filterReadiness: 'État',
    all: 'Tous',
    readinessReady: 'Prêt',
    readinessPartial: 'Partiel',
    readinessReplacementAvailable: 'Remplacement disponible',
    readinessReplacementExhausted: 'Remplacement épuisé',
    readinessMissing: 'Manquant',
    filterRole: 'Rôle',
    filterHeight: 'Hauteur',
    filterScope: 'Plongeurs',
    scopeSelf: 'Mes plongeons',
    scopeAll: 'Tous les plongeurs',
    scopeSelected: 'ID de plongeur choisi',
    filterDiverId: 'ID du plongeur',
    filterSort: 'Tri',
    sortNeedsCoverage: 'Couverture à compléter',
    sortFullyReady: 'Entièrement prêt',
    sortRecentlyUpdated: 'Récemment mis à jour',
    refresh: 'Actualiser',
    refreshing: 'Actualisation…',
    coverageLine: 'Affiche {{poster}}/{{total}} · Vidéo {{video}}/{{total}}',
    coverageIncomplete: 'Couverture incomplète',
    noRepresentative: 'Aucun représentant « {{role}} » sélectionné.',
    noMatches: 'Aucun résultat.',
    candidatesAria: 'Candidats de remplacement',
    candidates: 'Candidats de remplacement',
    noCandidates: 'Aucun candidat inutilisé.',
    scoreDistance: 'Distance de score',
    useWithoutPreparing: 'Utiliser sans préparation',
    useAndPrepare: 'Utiliser et préparer les manquants',
    findOrRetry: 'Trouvez un remplaçant, ou réessayez une fois l’extrait téléchargé dans Photos sur le Mac.',
    checkPermissions: 'Vérifiez les autorisations Photos sur le Mac, puis réessayez.',
    prepareOne: 'En préparer un',
    alreadyReady: '{{renditions}} déjà prêts',
    noCachedRendition: 'Aucun rendu en cache',
    heightMatch: 'Hauteur identique',
    heightDiffers: 'Hauteur différente',
    modifiersMatch: 'Modificateurs identiques',
    modifiersDiffer: 'Modificateurs différents',
    poster: 'Affiche',
    proxy: 'Proxy',
  },
  whatsNew: {
    title: 'Nouveautés',
    buttonAria: 'Nouveautés',
    unread: 'Mises à jour non lues',
    close: 'Fermer les détails des mises à jour',
    dismissHint: 'Fermer la notification de mise à jour',
    updateHeadline: 'Votre bibliothèque vient de recevoir une mise à jour',
    improvementsReady: '{{count}} améliorations sont prêtes à découvrir.',
    seeWhatsNew: 'Voir les nouveautés →',
    newerVersion: 'Une version plus récente est disponible',
    reloadHint: 'Rechargez quand vous êtes prêt(e) pour voir les dernières améliorations.',
    reloadApp: 'Recharger l’app',
    latestUpdate: 'Dernière mise à jour',
    noNotes: 'Aucune note de mise à jour disponible pour le moment.',
    gotIt: 'Compris, retour à mes plongeons',
    version: 'Version {{version}}',
  },
  notifications: {
    title: 'Notifications',
    heading: 'Notifications',
    headingDesc: 'Les nouvelles vidéos, les commentaires et les étapes marquantes arrivent ici.',
    openAria: 'Ouvrir les notifications',
    openAriaUnread: 'Ouvrir les notifications, {{count}} non lues',
    filterAria: 'Filtre des notifications',
    showAll: 'Tout afficher',
    unreadOnly: 'Non lues ({{count}})',
    markRead: 'Marquer comme lue',
    markAllRead: 'Tout marquer comme lu',
    saving: 'Enregistrement…',
    openDive: 'Ouvrir le plongeon',
    openSession: 'Ouvrir la séance',
    loading: 'Chargement des notifications…',
    emptyAll: 'Aucune notification pour le moment.',
    emptyUnread: 'Vous êtes à jour.',
    emptyHint: 'Les nouvelles vidéos et les commentaires apparaîtront ici.',
    errorLoad: 'Impossible de charger les notifications.',
    errorAction: 'Impossible d’enregistrer la modification. Réessayez.',
    unreadOnlyPending: 'Non lues',
    loadMore: 'Afficher les notifications plus anciennes',
    diveDate: 'Séance du {{date}}',
    listAria: 'Notifications',
    unreadBadge: 'Non lue',
    types: {
      new_video: 'Nouvelle vidéo',
      video_ready: 'Vidéo prête',
      new_comment: 'Nouveau commentaire',
      direct_message: "Messages",
      comment_reply: 'Réponse à un commentaire',
      milestone: 'Étape marquante',
      sync_error: 'Problème de synchro',
      guest_activity: 'Activité des invités',
      calendar_invitation: 'Invitation agenda',
      calendar_change: 'Changement agenda',
      calendar_reminder: 'Rappel agenda',
      calendar_group_reminder: 'Rappel de séance du groupe',
      calendar_follow: 'Agenda suivi',
    },
    calendar: {
      invitation: 'Vous êtes invité·e',
      change: 'Événement modifié',
      cancellation: 'Annulé',
      reminder: 'Demain',
      new_event: 'Nouvel événement',
      moved: 'Déplacé : {{from}} → {{to}}',
      venueChanged: 'Nouveau lieu : {{venue}}',
      venueChangedNoName: 'Lieu modifié',
      sessionCancelled: 'Séance annulée : {{when}}',
      eventCancelled: 'Cet événement est annulé.',
      more: '+{{count}} autres séances',
      openEvent: 'Ouvrir l’événement',
      redacted: 'Cette notification d’agenda ne vous est plus accessible.',
    },
  },
  downloads: {
    saveFailed: 'L’enregistrement du lot n’a pas pu se terminer',
    automaticError: 'Le téléchargement automatique est indisponible ici. Appuie sur chaque fichier ci-dessous pour le télécharger.',
    download: "Télécharger la vidéo",
    short: "Télécharger",
    requested: "Téléchargement demandé",
    close: "Fermer les téléchargements",
    retry: "Télécharger à nouveau",
    deviceHint: "Consulte les Téléchargements ou Fichiers de ton appareil. Si rien ne démarre, appuie sur Télécharger à nouveau.",
    preparing: "Préparation de la vidéo…",
    preparePhotos: "Préparer la vidéo pour Photos / le partage",
    photos: "Enregistrer dans Photos / partager",
    photosError: "Le partage vidéo est indisponible ici. Télécharge le fichier, puis enregistre-le dans Photos depuis Fichiers.",
    saved: "Clips enregistrés dans ta bibliothèque",
    saving: "Enregistrement de tes clips…",
    progress: "{{count}} téléchargement(s) demandé(s) sur {{total}}",
    batchHint: "Tes clips sont dans ta bibliothèque. Autorise les téléchargements multiples si ton navigateur le demande. Si un fichier ne se télécharge pas, appuie dessus ci-dessous pour réessayer.",
    saveError: "Impossible de terminer l’enregistrement de ce lot. Réessaie pour continuer ; les clips déjà enregistrés restent dans ta bibliothèque.",
    tryAgain: "Réessayer",
    saveDownload: "Enregistrer et télécharger tout",
    claimReady: "Tes {{count}} clip(s) seront acceptés dans ta bibliothèque et téléchargés sur cet appareil.",
  },
  claim: {
    title: 'Récupérer mes plongeons',
    ready: 'Tu as {{count}} clip(s) à passer en revue.',
    cta: 'Récupérer mes plongeons',
    signingIn: 'Connexion en cours…',
    invalid: 'Ce lien est invalide ou a déjà été utilisé.',
    backToLogin: 'Retour à la connexion',
    error: 'Le lien n’a pas pu être utilisé. Réessaie.',
  },
  deposits: {
    pendingTitle: 'Lots de plongeons en attente',
    pendingSubtitle: 'Consultez les clips déposés et suivez leur acceptation. Chaque plongeur accepte ses propres plongeons.',
    awaitingOwner: 'En attente de l’acceptation de {{name}}',
    readyForYou: 'Prêts à être acceptés par vous',

    title: 'Récupérer mes plongeons',
    titleBatch: '{{name}} — {{count}} clip(s) à passer en revue',
    subtitle: 'Accepte les clips un par un — ou tous d’un coup — et corrige le code, la hauteur ou ta note perso au passage.',
    empty: 'Rien à récupérer. Les nouveaux clips déposés apparaîtront ici.',
    batchRow: '{{name}} — {{count}} clip(s)',
    acceptAll: 'Tout accepter',
    acceptSelected: 'Accepter la sélection ({{count}})',
    selectAll: 'Tout sélectionner',
    unselectAll: 'Tout désélectionner',
    selectClip: 'Sélectionner le clip {{code}}',
    depositedBy: 'Déposé par {{name}}',
    yourNote: 'Ta note :',
    watch: 'Voir',
    edit: 'Modifier',
    code: 'Code du plongeon',
    height: 'Hauteur',
    note: 'Note perso',
    save: 'Enregistrer',
    cancel: 'Annuler',
    allDone: 'Tout est récupéré !',
    backToLibrary: 'Retour à la vidéothèque',
    errorLoad: 'Impossible de charger les clips en attente.',
    errorAction: 'Impossible d’enregistrer la modification. Réessaye.',
    banner: '{{count}} nouveau(x) clip(s) à récupérer',
    bannerCta: 'Voir',
    emailToggle: 'Emails de dépôt',
    emailToggleDesc: 'Un email par lot de clips déposés, avec lien de connexion',
  },
  pdv: {
    executionLabel: 'Exécution',
    signals: {
      technical: 'Ampleur technique',
      sameDiveResult: 'Résultat sur le même plongeon',
      breakthrough: 'Percée',
      progression: 'Progression',
      consistency: 'Régularité',
      novelty: 'Nouveauté',
    },
    levels: { high: 'Élevée', medium: 'Moyenne', low: 'Faible', undefined: 'Indisponible' },
    emergingConfidence: 'Émergent · {{count}} plongeons précédents identiques',
    unavailable: 'Indisponible',
    levelConfidence: 'Confiance : {{level}} · {{count}} plongeons précédents',
    noPatterns: 'Aucune séquence identique antérieure à comparer.',
    patternsAria: 'Correspondances de schémas historiques',
    closestPattern: 'Schéma précédent le plus proche',
    historicalMatch: 'Correspondance historique',
    earlier: 'Avant',
    vsCurrent: 'vs maintenant',
    titleUnavailable: 'Valeur de plongeon personnelle indisponible',
    titleError: 'Impossible de charger la valeur de plongeon personnelle',
    excluded: 'Exclu pour ce plongeon (p. ex. saut droit ou alignement).',
    noOfficialDD: 'La cotation officielle n’est pas définie pour ce plongeon.',
    version: 'Version {{version}}',
    provisional: 'Provisoire : pas assez d’historique sur ce même plongeon.',
    sameDivePercentile: '{{percentile}}e percentile sur le même plongeon. ',
    strongestContribution: '{{signal}} est la plus grande contribution.',
    historicalContext: 'Contexte historique',
    emerging: 'Émergent',
    primarySignal: 'Signal principal',
    confidence: 'Confiance',
    hideDetails: 'Masquer les détails',
    showDetails: 'Afficher les détails',
    whatContributed: 'Ce qui a contribué',
    basedOn: 'D’après {{count}} plongeons identiques antérieurs{{percentile}}.',
    percentileSuffix: ' · {{percentile}}e percentile',
    similarSequences: 'Séquences antérieures similaires',
    formula: 'Formule {{version}} · calculé à partir des plongeons antérieurs au {{cutoff}}.',
  },
  addVideos: {
    qualityHint: 'Les fichiers originaux sont conservés. La lecture garde leur résolution ; une copie SDR est préparée pour les vidéos HDR. Maximum : 1 Go, 3 minutes, 4K.',
    selectVideos: 'Sélectionner des vidéos',
    add: 'Ajouter des vidéos',
    noticeAdded: '{{count}} vidéo(s) ajoutée(s) à votre bibliothèque.',
    errorAdd: 'Impossible d’ajouter la vidéo. Votre extrait est conservé ici ; réessayez.',
    sizeNotice: 'Sélectionnez des vidéos non vides de moins de 1 Go chacune.',
    confirmStop: 'Arrêter l’ajout de vidéos ? Les extraits enregistrés restent dans votre bibliothèque ; les autres seront perdus.',
    videoN: 'Vidéo {{index}} / {{total}}',
    addedAs: 'Ajoutée comme {{name}}. Vérifiez la date : votre navigateur fournit la date de modification du fichier.',
    diver: 'Plongeur',
    myDiverN: 'Mon plongeur nº {{id}}',
    code: 'Code',
    height: 'Hauteur',
    rating: 'Note',
    date: 'Date',
    notes: 'Notes',
    visibleToCommunity: 'Visible par la communauté',
    evaluationRequest: 'Demander une évaluation communautaire',
    evaluationPrompt: 'Commentaire pour le jury',
    evaluationPromptPlaceholder: 'Sur quoi le jury doit-il se concentrer ?',
    uploading: 'Téléversement… {{progress}} %',
    preparing: 'Préparation de la vidéo… Gardez cette page ouverte.',
    skip: 'Passer cet extrait',
    saveAndFinish: 'Enregistrer et terminer',
    saveAndNext: 'Enregistrer et suivant',
    adding: 'Ajout…',
  },
  releaseNotes: {
    "evaluations-today-hub": {
      "title": "Les Évaluations vous accueillent avec les plongeons du jour",
      "body": "Ouvrez les Évaluations pour commencer la sélection du jour ou reprendre là où vous en étiez. Une fois la sélection terminée, vos cartons rejoignent ceux du jury, avec votre style de juge, votre série de jours consécutifs et le compte à rebours avant la prochaine sélection. Mes plongeons affiche les notes et un bouton pour participer aux sélections. L’Historique regroupe tous vos votes par jour."
    },
    "evaluations-french": {
      "title": "Les Évaluations entièrement en français",
      "body": "Les consignes, les cartons et les résumés du jury utilisent un vocabulaire cohérent et des virgules pour les notes décimales. L’annonce des nouveautés des Évaluations est également disponible en français."
    }
  },
  evaluations: {
    juryArea: 'Espace de jugement',
    judgeSection: 'Juger',
    pausedTitle: 'En pause · {{count}} restant(s) aujourd’hui',
    pausedResume: 'Retour au plongeoir',
    ripTitle: 'Entrée sans éclaboussure. ✓',
    ripNote: 'Plus rien à juger : {{count}} plongeon(s) noté(s) aujourd’hui.',
    emptyPoolTitle: 'Le bassin est vide',
    emptyPoolNote: 'Aucun plongeon public ne vous attend pour l’instant.',
    streak: '{{count}} jour(s) d’affilée',
    streakHint: 'Jours consécutifs avec au moins un vote de sélection du jour',
    tableAria: 'Vos cartons du jour',
    firstJudge: 'Premier juge',
    panelAlone: 'Aucun autre juge pour l’instant — vous placez la barre.',
    panelChip: 'Jury {{mean}}',
    persona: {
      ice: 'Le juge de glace 🧊',
      hard: 'Juge sévère',
      spot: 'Dans le mille 🎯',
      generous: 'Juge généreux',
      santa: 'Le Père Noël 🎅',
      unknown: 'Style de juge : encore à l’échauffement',
    },
    meterAria: '{{bias}} points par rapport au reste du jury',
    meterHarsh: 'Sévère',
    meterGenerous: 'Généreux',
    meterAbove: '{{delta}} au-dessus des autres juges en moyenne, sur {{count}} plongeon(s).',
    meterBelow: '{{delta}} en dessous des autres juges en moyenne, sur {{count}} plongeon(s).',
    meterLearning: 'Jugez encore {{count}} plongeon(s) notés par d’autres pour révéler votre style.',
    nextHand: 'Prochaine donne dans',
    nextHandAria: 'Prochaine sélection à {{time}}',
    warmUp: 'Le jury s’échauffe…',
    kindRequest: 'demande',
    sortAria: 'Trier mes plongeons',
    sort: { recent: 'Récents', top: 'Meilleure note', votes: 'Les plus notés' },
    rulesSummary: 'Comment fonctionnent les notes communautaires ?',
    judgesCount: '{{count}} juge(s)',
    inSelections: 'Dans les sélections',
    tabMyDives: 'Mes plongeons',
    tabHistory: 'Historique',
    todayMore: 'Juger {{count}} plongeons de plus',
    requestsTitle: 'Demandes d’avis',
    requestsPending: '{{count}} plongeon(s) attendent votre note.',
    requestsCta: 'Juger les demandes',
    judgedTotal: '{{count}} plongeon(s) jugé(s) au total',
    receiveSection: 'Recevoir',
    allNotes: '{{count}} notes',
    nextPage: 'Notes suivantes',
    wholeFrame: 'Voir le plongeon entier',
    done: 'Terminé',
    discardTitle: 'Quitter sans confirmer ?',
    discardDraft: 'Votre note et votre commentaire non confirmés seront perdus. Les notes enregistrées restent.',
    stay: 'Rester',

    automaticFooter: 'Les plongeons publics participent automatiquement. Gérez les exclusions dans Notes communautaires.',
    tabAutomatic: "Sélection du jour",
    tabCommunity: "Notes communautaires",
    drawSize: 'Plongeons par tirage',
    drawSizeHint: 'Pour les nouvelles sélections quotidiennes et supplémentaires. Enregistré pour votre compte dans ce navigateur ; les sélections en cours gardent leur taille.',
    dailyStart: "Commencer / reprendre la sélection du jour",
    automaticNote: "Jusqu’à {{count}} plongeons publics d’autres membres. Une sélection plus courte est normale avec une petite communauté. Renouvellement quotidien à minuit UTC.",
    automaticFinished: "Sélection terminée ou aucun plongeon éligible disponible. Les votes sauvegardés restent séparés des évaluations demandées.",
    anotherStack: "Demander une autre sélection",
    resumeStack: "Reprendre cette sélection",
    communityNote: "Les plongeons publics peuvent être sélectionnés automatiquement. Vous pouvez exclure chaque plongeon ci-dessous. Ces notes expérimentales restent provisoires : un vote automatique par membre et par plongeon, séparé des évaluations demandées et des notes officielles. Elles ne constituent pas un classement des plongeurs.",
    communityScore: "{{score}} / 10 · {{count}} évaluateurs · provisoire",
    noPublicDives: "Aucun plongeon public avec vidéo.",
    includeAutomatic: "Inclure dans les sélections automatiques",
    excludeAutomatic: "Exclure des sélections automatiques",
    previousPage: "Précédent",

    label: 'Évaluation communautaire',
    toggleAria: 'Demander une évaluation communautaire pour ce plongeon',
    prompt: 'Commentaire pour le jury (facultatif)',
    promptPlaceholder: 'Sur quoi le jury doit-il se concentrer ?',
    savePrompt: 'Enregistrer le commentaire',
    error: 'Impossible de mettre à jour la demande d’évaluation. Réessayez.',
    mediaPending: 'Vidéo en préparation.',
    quit: 'Quitter la série',
    previous: 'Précédent',
    commentAdd: 'Ajouter un commentaire',
    backToScore: 'Revenir au clavier de notes',
    composerNeedScore: 'Choisissez d’abord une note',
    composerFor: 'Votre note {{score}} — envoyez pour confirmer',
    sendAria: 'Confirmer {{score}} avec ce commentaire',
    promptFold: 'Consigne du jury',
    hqUpgrading: 'HD en préparation…',
    commentSavedOnConfirm: 'Le commentaire est enregistré avec votre note confirmée.',
    commentEdit: 'Modifier le commentaire',
    commentsToggle: 'Commentaires',
    chooseScore: 'Choisissez votre note',
    ariaScoreOf: '{{score}} sur 10',
    stepUpAria: 'Demi-point au-dessus',
    stepDownAria: 'Demi-point en dessous',
    you: 'Vous',
    requestDive: 'Faire évaluer un plongeon',
    requestDiveHint: 'Le propriétaire ouvre une évaluation depuis la Bibliothèque : bascule « Demander une évaluation communautaire » sur un plongeon ou pendant un ajout.',
    mediaChecking: 'Vérification de la vidéo…',
    keepOpenShort: 'Garder',
    qualityLabelAria: 'Qualité de la vidéo',
    qualityHQ: 'HD',
    qualityOriginal: 'Originale',
    mediaFailed: 'La vidéo n’a pas pu être préparée. Réessayez.',
    playerControlsAria: 'Commandes vidéo',
    replayAria: 'Rejouer depuis le début',
    pauseAria: 'Pause',
    playAria: 'Lecture',
    soundOnAria: 'Activer le son',
    soundOffAria: 'Couper le son',
    slowAria: 'Ralenti',
    slowLabel: 'Ralenti',
    mediaRetry: 'Réessayer',
    title: 'Évaluations',
    lede: 'Jugez les plongeons du club et recueillez des notes sur les vôtres.',
    tabsAria: 'Sections Évaluations',
    tabJury: 'Juger une série',
    tabMine: 'Mes évaluations',
    tabJudgements: 'Mes jugements',
    footerHint: 'Le propriétaire ouvre une évaluation depuis la Bibliothèque ou pendant l’ajout (bascule d’évaluation).',
    backToLibrary: 'Ouvrir la Bibliothèque',
    signInNeeded: 'Connectez-vous pour juger ou suivre vos évaluations.',
    start: 'Commencer à juger',
    startNote: 'Les plongeons arrivent par petits lots ; vous pouvez quitter et revenir quand vous voulez.',
    introHint: 'Présentation du jury',
    introSkip: 'Passer',
    introDemo: 'Cartons de démonstration — aucune note réelle',
    counted: '{{count}} plongeon(s) évalué(s)',
    loadError: 'La file d’évaluation est indisponible. Réessayez.',
    retry: 'Réessayer',
    judgeAria: 'Actions de jugement',
    scoreAria: 'Note de 0 à 10 par demi-point',
    noScore: 'Pas encore de note choisie',
    cardAria: 'Carton de note {{score}}',
    myCardAria: 'Votre carton {{score}}',
    scoreHint: '0 à 10 par demi-point',
    commentAria: 'Commentaire facultatif',
    commentPlaceholder: 'Commentaire facultatif pour le plongeur…',
    pass: 'Passer',
    confirm: 'Confirmer la note',
    saving: 'Enregistrement de votre note…',
    next: 'Plongeon suivant',
    keepOpen: 'Garder les résultats ouverts',
    panelSummary: '{{count}} vote(s) · moyenne communautaire {{mean}}',
    exhausted: 'Plus rien à juger pour l’instant. Les nouvelles demandes apparaîtront ici.',
    evaluateAgain: 'Juger une nouvelle série',
    mediaMissing: 'Vidéo indisponible. Réessayez ou passez ce plongeon.',
    mediaClosed: 'Cette évaluation a été fermée pendant votre visionnage. Rien n’a été enregistré.',
    voteClosed: 'Cette évaluation vient de se fermer — aucun vote n’a été enregistré.',
    voteSelf: 'Impossible de juger votre propre plongeon.',
    voteAlready: 'Votre jugement est déjà confirmé et immuable.',
    voteError: 'La note n’a pas pu être enregistrée. Votre choix est conservé ; réessayez.',
    sessionNew: 'Nouvelle série : les plongeons passés reviennent, ceux déjà notés sont exclus.',
    unknownOwner: 'Plongeur inconnu',
    ownedCount: '{{count}} demande(s)',
    ownedEmpty: 'Aucune demande pour l’instant. Ouvrez-en une depuis la Bibliothèque ou pendant un ajout.',
    ownedActive: 'Active',
    ownedClosed: 'Évaluation fermée',
    ownedError: 'Vos demandes d’évaluation sont indisponibles. Réessayez.',
    showPanel: 'Afficher le jury',
    hidePanel: 'Masquer le jury',
    panelEmpty: 'Aucun vote pour l’instant.',
    panelError: 'Le jury est indisponible.',
    more: 'Afficher plus',
    judgedCount: '{{count}} jugement(s)',
    judgedEmpty: 'Vous n’avez encore jugé aucun plongeon.',
    judgedError: 'Vos jugements sont indisponibles. Réessayez.',
    summaryJudged: 'Vous avez jugé {{count}} plongeon(s) dans cette série.',
    summarySkipped: 'Les plongeons passés reviendront dans votre prochaine série.',
  },
  sessions: {
    title: 'Séances d’entraînement',
    sessions: 'Séances',
    errorLoad: 'Échec du chargement des séances',
    today: 'Aujourd’hui',
    yesterday: 'Hier',
    avgPerSession: 'Moyenne par séance',
    scopeAria: 'Champ de plongeurs de la séance',
    everyone: 'Tout le monde',
    myAttempts: 'Mes plongeons',
    inScope: 'Dans le champ',
    none: 'Aucune séance pour le moment.',
    loadMore: 'Charger plus de séances',
  },
  sessionDetail: {
    errorLoad: 'Échec du chargement des détails de la séance',
    close: 'Fermer les détails de la séance',
    bestDive: 'Meilleur plongeon',
    diveSequence: 'Enchaînement des plongeons',
    videoAvailable: 'Vidéo disponible',
    videoPlayback: 'Lecture vidéo',
    noVideoSelected: 'Aucune vidéo sélectionnée.',
    performanceFlow: 'Flux de performance',
    noScoredAttempts: 'Aucun plongeon noté dans cette séance.',
    heightDistribution: 'Répartition par hauteur',
    noHeightData: 'Aucune donnée de hauteur',
    comparison: 'Comparaison avec la séance précédente',
  },
  recall: {
    title: 'Rappel de médias',
    refresh: 'Actualiser',
    unknown: 'Inconnu',
    unknownLower: 'inconnu',
    gib: '{{value}} Gio',
    loadError: 'Impossible de charger les opérations de rappel',
    requestError: 'Impossible de demander cette source',
    catalogStartError: 'Impossible de lancer le catalogue',
    nodeStatusAria: 'État du nœud média Mac',
    worker: 'Agent',
    notRegistered: 'Non enregistré',
    leasingEnabled: 'Attribution activée',
    leasingDisabled: 'Attribution désactivée',
    photosAccess: 'Accès à Photos',
    lastQuery: 'Dernière requête : {{when}}',
    notRecorded: 'non enregistrée',
    managedSources: 'Sources gérées',
    permanentRecent: 'Permanentes {{permanent}} · Récentes {{recent}}',
    internalFree: 'Espace interne libre',
    emergencyStop: 'Arrêt d’urgence sous 18 Gio',
    disabledWhilePhotos: 'Le rappel reste désactivé tant que l’accès à Photos est {{status}}.',
    historicalPaused: 'Le rappel historique est suspendu par le seuil d’espace libre interne.',
    catalogAria: 'Catalogue des médias légendés',
    catalogTitle: 'Catalogue des vidéos légendées',
    catalogRunning: 'Catalogue en cours',
    startCatalog: 'Lancer le catalogue',
    runState: 'État de l’exécution',
    notStarted: 'Non démarré',
    revision: 'Révision {{revision}}',
    observed: 'Observées',
    checkpoint: 'Point de reprise {{value}}',
    eligible: 'Éligibles',
    mappedParseable: 'Associées et lisibles',
    playable: 'Lisibles',
    posterProxyReady: 'Affiche + proxy prêts',
    excluded: 'Exclues',
    paused: 'En pause : {{reason}}',
    populationTitle: 'Plan de remplissage progressif',
    planPopulation: 'Planifier le remplissage',
    alreadyReady: 'Déjà prêtes',
    rollingPeak: 'Pic progressif',
    projectedFree: 'Espace libre prévu',
    execution: 'Exécution',
    allowed: 'Autorisée',
    batchTitle: 'Plan des plongeons typiques sans média prêt',
    planBatch: 'Planifier un lot limité',
    items: 'Éléments',
    peak: 'Pic',
    gate: 'Seuil',
    manifestTitle: 'Manifeste de rappel limité',
    itemsShown: '{{count}} éléments affichés',
    typical: 'Typique',
    attempt: 'Plongeon',
    unknownDiver: 'Plongeur inconnu',
    poster: 'Affiche',
    video: 'Vidéo',
    requesting: 'Demande en cours…',
    recallOne: 'Rappeler',
    colDive: 'Plongeon',
    colReason: 'Motif',
    colSource: 'Source',
    colMedia: 'Média',
    colDate: 'Date',
    colAction: 'Action',
    noItems: 'Aucun élément à rappeler.',
  },
  ddWorkspace: {
    loadingAria: 'Chargement de la cotation',
    loadError: 'Impossible de charger les données de cotation.',
    title: 'Cotation',
    view: 'Vue',
    scopeAria: 'Périmètre de la cotation',
    myDives: 'Mes plongeons',
    allDivers: 'Tous les plongeurs',
    definedAttempts: 'Plongeons cotés',
    definedOf: '{{defined}} sur {{total}}',
    combinations: '{{count}} combinaisons plongeon et hauteur',
    medianDD: 'Cotation médiane',
    highestDD: 'Cotation maximale',
    notDefined: 'Non définie',
    monthlyRange: 'Plage mensuelle de cotation',
    monthsCount: '{{count}} mois',
    heightContext: 'Contexte par hauteur',
    attemptsCount: '{{count}} plongeons',
    medianValue: 'Médiane {{value}}',
    maxValue: 'Max {{value}}',
    inventory: 'Inventaire des cotations enregistrées',
    legacyMismatch: '{{count}} cotations anciennes enregistrées diffèrent du résultat de la formule.',
    excludedFromOfficial: 'Exclus de la cotation officielle : {{list}}',
  },
  avoidedDives: {
    loadError: 'Échec du chargement de l’analyse des plongeons évités',
    none: 'Aucun plongeon évité.',
    title: 'Plongeons évités',
    notAttempted_one: '{{count}} plongeon non tenté récemment.',
    notAttempted_other: '{{count}} plongeons non tentés récemment.',
    avoidanceScore: 'Score d’évitement',
    daysAway: 'Jours d’absence',
    difficulty: 'Difficulté',
    daysWithoutAttempt: 'Jours sans tentative',
    daysCount: '{{count}} jours',
    attempts: 'Tentatives',
    lastPerformance: 'Dernière performance :',
    performance: {
      F: 'Manqué',
      B: 'Mauvais',
      M: 'Moyen',
      G: 'Bon',
      P: 'Parfait',
    },
  },
  mentalBlock: {
    none: 'Aucun blocage mental détecté',
    ddPlateau: 'Plateau de cotation',
    repeatedFailure: 'Schéma d’échecs répétés',
    avoidedDive: 'Plongeon évité',
    summary: '{{months}} • Concerne {{dives}}',
    months_one: '{{count}} mois',
    months_other: '{{count}} mois',
    dives_one: '{{count}} plongeon',
    dives_other: '{{count}} plongeons',
    affectedDives: 'Plongeons concernés :',
    recoveryPlan: 'Plan de récupération :',
    checkProgress: 'Vérifier la progression',
    dismiss: 'Ignorer',
  },
  clipNav: {
    previous: 'Précédent',
    next: 'Suivant',
    speed: 'Vitesse',
    playbackSpeed: 'Vitesse de lecture',
    positionAria: 'Position {{index}} sur {{total}} dans la liste courante',
  },
  sessionDirection: {
    label: 'Groupes :',
    short: {
      1: 'Av.',
      2: 'Arr.',
      3: 'Renv.',
      4: 'Ret.',
      5: 'Vri.',
    },
  },
  videoPlayer: {
    loadingVideo: 'Chargement de la vidéo',
    preparingTitle: 'Vidéo en préparation',
    preparingHint: 'Elle arrive depuis votre Mac, en général en moins d’une minute.',
    preparingSlow: 'Ça prend plus de temps que d’habitude.',
    preparingPaused: 'Préparation en pause',
    connectionLost: 'Connexion interrompue',
    tryAgainHint: 'Réessayez dans un instant.',
    retry: 'Réessayer',
    steps: { retrieve: 'Récupération', convert: 'Conversion', send: 'Envoi' },
    unreachableTitle: 'Connexion impossible',
    unreachableHint: 'Vérifiez votre connexion puis réessayez.',
    unavailableTitle: 'Vidéo indisponible',
    unavailableHint: 'Cette vidéo ne peut pas être lue pour le moment.',
    unavailablePrepareHint: 'La préparation a échoué. Vous pouvez la relancer.',
    prepareAgain: 'Relancer la préparation',
    signInToPlay: 'Connectez-vous pour lire',
    sessionExpired: 'Session expirée.',
    signIn: 'Se connecter',
    videoAria: 'Vidéo du plongeon {{code}} {{height}}',
    statusCheckFailed: 'Échec de la vérification de l’état du média',
    retryStatusCheck: 'Réessayer la vérification',
    mediaReady: 'Média prêt.',
    checking: 'Vérification…',
    lastKnownState: 'Dernier état connu : {{state}}',
    statusChecksStopped: '{{state}} — vérifications arrêtées',
    connectionInterrupted: '{{state}} — connexion interrompue',
    stillPreparing: 'Préparation toujours en cours',
    preparingMedia: 'Préparation du média : {{state}}',
    checkStatusAgain: 'Vérifier à nouveau l’état',
    checkStatusNow: 'Vérifier l’état maintenant',
    noVideo: 'Aucune vidéo disponible',
    prepareFailed: 'Échec de la préparation du média',
    requestFailed: 'Impossible de demander la préparation du média',
    requesting: 'Demande en cours…',
    retryPrepare: 'Réessayer la préparation',
    usePreview: 'Lire un aperçu de qualité réduite',
    changeQuality: 'Changer la qualité vidéo',
    qualityCycle: '{{current}} — cliquer pour changer de qualité',
    originalQuality: 'Originale',
    previewLabel: 'Aperçu',
    lightLabel: 'Léger',
    hqLabel: 'HQ',
    previewQuality: 'Aperçu de qualité réduite',
    loadFailed: 'Échec du chargement de la vidéo',
    tryAgain: 'Réessayer',
    notCached: 'Extrait non mis en cache',
    prepareClip: 'Préparer l’extrait',
    noPlayable: 'Aucun média lisible pour cet extrait pour le moment.',
    posterUnavailable: 'Aucune image d’aperçu disponible',
    states: {
      queued: 'en file d’attente',
      waiting_for_mac: 'en attente du Mac',
      claimed: 'pris en charge',
      materializing: 'récupération de la vidéo source',
      exporting: 'export en cours',
      transcoding: 'transcodage en cours',
      uploading: 'envoi en cours',
      verifying: 'vérification en cours',
    },
  },
  nav: {
    sessionVideos: 'Vidéos de séance',
    calendar: 'Calendrier',
    messages: "Messages",
    messagesUnreadAria: "Messages, {{count}} non lus",
    community: "Communauté",
    dives: 'Bibliothèque',
    evaluations: 'Évaluations',
    overview: 'Aperçu',
    journey: 'Parcours',
    analytics: 'Analytique',
    representatives: 'Représentantes',
    sessions: 'Séances',
    notifications: 'Notifications',
    mediaRecall: 'Rappel de médias',
    system: 'Système',
    account: 'Compte',
    operations: 'Opérations',
    operationsAria: 'Navigation des opérations',
    playerCanary: 'Test du lecteur',
    review: 'Révision',
    workspace: 'Espace de travail',
    primaryNavigationAria: 'Navigation principale',
    secondaryNavigationAria: 'Navigation secondaire',
    myProfile: 'Mon profil',
    accountNavigationAria: 'Navigation du compte',
    workspaceSidebarAria: 'Barre latérale de l’espace',
    openNavigation: 'Ouvrir la navigation',
    closeNavigation: 'Fermer la navigation',
    skipToContent: 'Passer au contenu principal',
  },
  roles: {
    diver: 'plongeur',
    administrator: 'administrateur',
    Diver: 'Plongeur',
    Administrator: 'Administrateur',
  },
  breadcrumbs: { analysis: 'analyse' },
  notFound: {
    title: 'Page introuvable',
    body: 'Rien ne se trouve à cette adresse.',
    backToLibrary: 'Retour à la bibliothèque',
  },
  login: {
    title: 'Connexion',
    email: 'Adresse courriel',
    password: 'Mot de passe',
    submit: 'Se connecter',
    signingIn: 'Connexion en cours…',
    staySignedIn: 'Rester connecté pendant 30 jours',
    newHere: 'Nouveau ici ?',
    createDiverAccount: 'Créer un compte de plongeur',
    invalidCredentials: 'Adresse courriel ou mot de passe incorrect',
    networkError: 'Erreur réseau — veuillez réessayer',
  },
  register: {
    club: 'Club',
    clubNone: 'Aucun club (plongeur indépendant)',
    clubHelp: 'Déclaratif : choisir un club vous en rend membre immédiatement. Ce n’est pas une licence vérifiée et cela ne donne ni groupe d’entraînement ni rôle d’entraîneur ; un entraîneur attribue les groupes.',
    errorClub: 'Ce club n’est plus disponible. Choisissez une autre option.',
    subtitle: 'Compte plongeur — consulter les plongeons publics et gérer les vôtres.',
    closed:
      'Les inscriptions sont actuellement fermées. Demandez un code d’invitation valide à un administrateur.',
    displayName: 'Nom affiché',
    confirmPassword: 'Confirmer le mot de passe',
    inviteCode: 'Code d’invitation',
    invitePlaceholder: 'Partagé par un administrateur',
    creating: 'Création du compte…',
    submit: 'Créer le compte de plongeur',
    alreadyHaveAccount: 'Vous avez déjà un compte ?',
    errorMismatch: 'Les mots de passe ne correspondent pas',
    errorTooShort: 'Le mot de passe doit comporter au moins 10 caractères',
    errorInvite: 'Code d’invitation invalide',
    errorExists: 'Un compte existe déjà avec cette adresse courriel',
    errorTooMany: 'Trop de tentatives — veuillez réessayer plus tard',
    errorFailed: 'Échec de l’inscription — veuillez vérifier vos informations',
  },
  invite: {
    errorClub: 'Ce club n’est plus disponible. Choisissez une autre option.',
    subtitle: 'Vous êtes invité(e) à récupérer les plongeons de',
    unknownDiver: 'votre plongeur',
    expiresOn: 'Ce lien expire le {{date}}',
    invalid: 'Ce lien d’invitation est invalide ou a déjà été utilisé.',
    invalidHint: 'Demandez une nouvelle invitation à la personne qui vous a invité(e).',
    backToLogin: 'Retour à la connexion',
    creating: 'Création de votre compte…',
    submit: 'Créer mon compte',
    errorMismatch: 'Les mots de passe ne correspondent pas',
    errorTooShort: 'Le mot de passe doit contenir au moins 10 caractères',
    errorLink: 'Ce lien d’invitation est invalide ou a déjà été utilisé.',
    errorClaimed: 'Ces plongeons appartiennent déjà à un autre compte. Demandez un nouveau lien, ou connectez-vous.',
    errorExists: 'Un compte existe déjà avec cette adresse courriel — connectez-vous',
    errorTooMany: 'Trop de tentatives — veuillez réessayer plus tard',
    errorFailed: 'Échec de la création du compte — veuillez vérifier vos informations',
  },
  fedUI: {
    title: 'Publication croisée sur le fédiverse',
    subtitle: 'Affiche + légende. Pas de vidéo, pas de lien vidéo.',
    switchAria: 'Autoriser la publication croisée sur le fédiverse pour ce plongeon',
    onlyPublic: 'Seuls les plongeons publics peuvent être fédérés',
    checking: 'Vérification de l’admissibilité…',
    neverPublishesNote: 'Activer ceci ne publie jamais les plongeons passés — chaque plongeon nécessite sa propre activation.',
    copied: 'Texte de publication croisée copié',
    copyText: 'Copier le texte de publication croisée',
    copiedNote: 'Affiche et légende copiées. Ne collez pas un lien de partage — il lit la vidéo d’origine. Joignez vous-même l’image d’affiche lors de la publication.',
    errorStatus: 'Statut du fédiverse indisponible.',
    errorCrossPost: 'Publication croisée indisponible — vérifiez les activations ci-dessus.',
    reason: {
      globalOff: 'Activez d’abord le partage sur le fédiverse dans Profil et réglages.',
      divePrivate: 'Seuls les plongeons publics peuvent être fédérés. Les plongeons privés restent locaux.',
      optInOff: 'Activez ce plongeon pour permettre une publication croisée manuelle.',
      eligible: 'Admissible à une publication croisée manuelle (affiche + légende, sans lien vidéo).',
    },
  },
  account: {
    title: 'Profil et réglages',
    signedInAs: 'Connecté en tant que',
    diverHint:
      'Vous pouvez consulter les plongeons publics partagés par les plongeurs et gérer vos propres plongeons. Les plongeons privés ne sont visibles que de leurs propriétaires. Un mot de passe oublié doit être réinitialisé par un administrateur.',
    adminHintLink: 'Gérer les utilisateurs dans Administration',
    adminHint:
      ' — créer des comptes de plongeurs et d’administrateurs, réinitialiser les mots de passe et gérer les associations de plongeurs.',
    managedByAdmin:
      'Les détails du profil sont gérés par votre administrateur. Pour changer votre nom affiché, adressez-vous à un administrateur.',
    diverScore: {
      title: 'Score plongeur',
      subtitle: 'Un score composite de 0 à 100 pour votre compte : qualité des plongeons, évaluations et présence communautaire.',
      provisional: 'Provisoire',
      performance: 'Performance {{mean}} / 10 sur {{count}} votes',
      judging: '{{count}} plongeons évalués',
      community: '{{count}} interactions communautaires',
    },
    notifications: 'Notifications',
    notificationsStored: 'Les alertes dans l’app sont synchronisées avec votre compte ; le courriel et le récapitulatif restent sur cet appareil pour l’instant.',
    notifInApp: 'Alertes dans l’app',
    notifInAppDesc: 'Synchronisées avec votre compte depuis le serveur.',
    notifOnDevice: 'Sur cet appareil',
    notifLoadError: 'Impossible de charger les réglages. Affichage des dernières valeurs connues.',
    notifSaveError: 'Impossible d’enregistrer. Réessayez.',
    notifSaving: 'Enregistrement…',
    notifNewVideo: 'Alertes de nouvelle vidéo',
    notifNewVideoDesc: 'Une nouvelle vidéo arrive dans votre bibliothèque',
    notifVideoReady: 'Alertes de vidéo prête',
    notifVideoReadyDesc: 'Le traitement est terminé et la lecture est disponible',
    notifNewComment: 'Alertes de commentaire',
    notifNewCommentDesc: 'Quelqu’un commente un plongeon partagé',
    notifCommentReply: 'Alertes de réponse',
    notifCommentReplyDesc: 'Quelqu’un répond à votre commentaire',
    notifSyncError: 'Alertes de synchro',
    notifSyncErrorDesc: 'Une synchronisation demande votre attention',
    notifGuestActivity: 'Alertes d’activité des invités',
    notifGuestActivityDesc: 'Sur demande : mentions « j’aime » et commentaires des invités',
    notifCalendarHeading: 'Agenda',
    notifCalendarDesc: 'Sur l’écran verrouillé, les aperçus des événements du club et privés restent génériques.',
    notifCalendarInvitation: 'Invitations',
    notifCalendarInvitationDesc: 'Quelqu’un vous invite à un événement',
    notifCalendarChange: 'Changements et annulations',
    notifCalendarChangeDesc: 'Horaire, lieu ou annulation des événements qui vous intéressent, où vous êtes invité·e, ou des séances de votre groupe',
    notifCalendarReminder: 'Rappel la veille',
    notifCalendarReminderDesc: 'Pour les séances marquées « Ça m’intéresse »',
    notifCalendarGroupReminder: 'Rappel pour chaque séance du groupe',
    notifCalendarGroupReminderDesc: 'Sur demande : la veille de chaque séance de votre groupe, sauf absence signalée',
    notifCalendarFollow: 'Événements et agendas suivis',
    notifCalendarFollowDesc: 'Nouveaux événements et changements dans ce que vous suivez (jamais les imports groupés du club)',
    notifEmail: 'Notifications par courriel',
    notifEmailDesc: 'Sur cet appareil uniquement pour l’instant — l’envoi par courriel arrivera dans une mise à jour ultérieure',
    notifMilestones: 'Alertes d’étapes marquantes',
    notifMilestonesDesc: 'Records personnels et séries de réussites',
    notifDigest: 'Récapitulatif hebdomadaire',
    notifDigestDesc: 'Sur cet appareil uniquement pour l’instant — le récapitulatif du serveur arrivera dans une mise à jour ultérieure',
    pushTitle: 'Notifications push sur cet appareil',
    pushDesc: 'Recevez des alertes même quand l’app est fermée. Seuls les types d’alertes activés ci-dessus peuvent envoyer un push — jamais de spam.',
    pushEnable: 'Activer le push sur cet appareil',
    pushDisable: 'Désactiver le push sur cet appareil',
    pushWorking: 'Traitement…',
    pushOn: 'Activé — cet appareil reçoit les alertes push.',
    pushOff: 'Désactivé — cet appareil ne reçoit aucun push.',
    pushUnsupportedBrowser: 'Le push n’est pas pris en charge dans ce navigateur.',
    pushUnsupportedServer: 'Le push n’est pas encore configuré sur le serveur.',
    pushBlocked: 'Les notifications sont bloquées pour ce site. Autorisez-les dans les réglages du navigateur, puis réessayez.',
    pushIosHint: 'iPhone ou iPad : ajoutez d’abord l’app à l’écran d’accueil (Partager → Sur l’écran d’accueil). Nécessite iOS 16.4 ou ultérieur.',
    pushError: 'Impossible de modifier les réglages push. Réessayez.',
    changePassword: 'Changer le mot de passe',
    currentPassword: 'Mot de passe actuel',
    newPassword: 'Nouveau mot de passe',
    newPasswordHint: '(10 caractères ou plus)',
    confirmNewPassword: 'Confirmer le nouveau mot de passe',
    changing: 'Modification…',
    sessions: 'Sessions',
    sessionsHint: 'Cette session prend fin quand vous vous déconnectez.',
    security: 'Sécurité',
    signOut: 'Se déconnecter',
    errorMismatch: 'Les nouveaux mots de passe ne correspondent pas',
    errorTooShort: 'Le nouveau mot de passe doit comporter au moins 10 caractères',
    errorWrongPassword: 'Mot de passe actuel incorrect',
    errorChangeFailed: 'Échec du changement de mot de passe — veuillez réessayer',
    errorNetwork: 'Erreur réseau — veuillez réessayer',
    passwordChanged: 'Mot de passe modifié. Les autres sessions ont été déconnectées.',
    fediverse: {
      section: 'Fédiverse',
      heading: 'Partage sur le fédiverse',
      description: 'Publications croisées manuelles vers les réseaux sociaux ouverts (Mastodon, Pixelfed). Désactivé par défaut.',
      noteAria: 'L’activation ne publie pas les plongeons existants',
      noteStrong: 'Activer ceci ne publie encore rien.',
      noteLocal: 'Vos plongeons publics existants restent locaux.',
      notePublicWord: 'publics',
      noteOptIn: 'Chaque plongeon nécessite ensuite sa propre activation — les plongeons privés ne sont jamais concernés.',
      noteContentWord: 'seulement l’affiche et la légende',
      noteContent: ' Pas de vidéo ni de lien vidéo (un lien de partage lit la vidéo d’origine ; n’en collez jamais).',
      noteAttach: 'Joignez l’image d’affiche vous-même lors de la publication.',
      statusOn: 'Activé — vous pouvez activer les plongeons publics un par un.',
      statusOff: 'Désactivé — aucun plongeon ne peut être publié.',
      saving: 'Enregistrement…',
      errorLoad: 'Réglages du fédiverse indisponibles. Réessayez.',
      errorSave: 'Impossible d’enregistrer. Réessayez.',
      step1: 'Étape 1 : activez ceci. Rien n’est publié.',
      step2: 'Étape 2 : ouvrez un plongeon public → activez « Publication croisée sur le fédiverse » pour ce plongeon.',
      step3: 'Étape 3 : utilisez « Copier le texte de publication croisée » et joignez l’affiche vous-même. Ne collez jamais un lien de partage.',
      behaviorNote: 'Fonctionne également sur téléphones, tablettes et ordinateur — cet avertissement est toujours affiché, sans étapes au survol.',
    },
    sectionsAria: 'Sections du profil',
    sections: { profile: 'Profil', activity: 'Activité', notifications: 'Notifications', security: 'Sécurité' },
    profileAria: 'Profil',
    notificationsAria: 'Notifications',
    securityAria: 'Sécurité',
    activity: {
      title: 'Historique d’activité',
      subtitle: 'Interactions sur vos plongeons et vos propres interactions. Cliquez sur un nom pour le profil du membre, ou sur un plongeon pour l’ouvrir.',
      tabsAria: 'Filtre d’activité',
      tabs: { all: 'Tout', received: 'Reçu', sent: 'Envoyé' },
      empty: 'Aucune activité — les likes et commentaires sur vos plongeons apparaîtront ici.',
      emptySent: 'Vos likes et commentaires sur les plongeons visibles apparaîtront ici.',
      loading: 'Chargement de l’activité…',
      loadOlder: 'Charger les activités plus anciennes',
      errorLoad: 'Historique d’activité indisponible. Réessayez.',
      guestNote: 'Les invités des liens de partage sont affichés avec leur nom d’affichage uniquement.',
      trail: {
        sent: {
          dive_like: 'Vous avez aimé le plongeon',
          comment: 'Vous avez commenté le plongeon',
          comment_like: 'Vous avez aimé un commentaire sur le plongeon',
        },
        received: {
          dive_like: 'a aimé votre plongeon',
          comment: 'a commenté votre plongeon',
          comment_like: 'a aimé votre commentaire sur',
        },
      },
    },
  },
  avatar: { title: 'Photo de profil', description: 'Votre photo et votre HUD vous suivent sur les profils, les commentaires et l’activité.', upload: 'Ajouter une photo', replace: 'Remplacer la photo', hud: 'Choisir votre HUD', orbit: 'Orbite', reticle: 'Réticule', depth: 'Profondeur', saved: 'Enregistré — votre identité est à jour.' },
  achievements: {
    title: "Succès",
    loading: "Chargement des succès…",
    errorLoad: "Impossible de charger les succès.",
    emptyOther: "Aucun succès débloqué pour l'instant.",
    summary: "{{unlocked}} sur {{total}} débloqués",
    locked: "verrouillé",
    unlockedOn: "Débloqué le {{date}}",
    unlocked: "Succès débloqué",
    unlockedMany: "{{count}} succès débloqués",
    view: "Voir mes succès",
    dismiss: "Fermer",
    categories: {
      profile: "Profil",
      community: "Communauté",
      jury: "Jury",
      dives: "Plongeons",
    },
    items: {
      profile_photo: { title: "Belle photo", description: "Ajoutez une photo de profil." },
      profile_handle: { title: "Plaque d'identité", description: "Choisissez votre @pseudo." },
      profile_bio: { title: "Dites-en plus", description: "Rédigez votre bio." },
      profile_complete: { title: "Profil au complet", description: "Complétez votre profil : photo, pseudo et bio." },
      first_like: { title: "Premier like", description: "Likez un plongeon." },
      likes_25: { title: "Fan club", description: "Likez 25 plongeons." },
      first_comment: { title: "Premier commentaire", description: "Commentez un plongeon." },
      first_reply: { title: "On en parle", description: "Répondez à un commentaire." },
      comments_10: { title: "Voix régulière", description: "Écrivez 10 commentaires ou réponses." },
      first_mention: { title: "Interpellé", description: "Mentionnez un membre avec @ dans un commentaire ou un message." },
      first_message: { title: "Premier message", description: "Envoyez un message privé." },
      first_like_received: { title: "Quelqu'un a remarqué", description: "Recevez un like sur l'un de vos plongeons." },
      first_comment_received: { title: "Un retour", description: "Recevez un commentaire sur l'un de vos plongeons." },
      first_rating: { title: "Au jury", description: "Notez un plongeon comme juge de la communauté." },
      ratings_10: { title: "Juge aguerri", description: "Notez 10 plongeons comme juge." },
      first_evaluation_request: { title: "Jugez-moi", description: "Demandez à la communauté de juger l'un de vos plongeons." },
      first_share: { title: "Partager l'éclaboussure", description: "Partagez un plongeon avec un lien." },
    },
  },
  community: {
    results: 'Résultats',
    recentlyActive: 'Actifs récemment',
    divers: 'Plongeurs',
    otherMembers: 'Autres membres',
    you: 'Vous',
    codes: 'Codes',
    board: {
      title: 'Classements',
      week: 'Semaine',
      month: 'Mois',
      periodAria: 'Période du classement',
      categoryAria: 'Catégorie du classement',
      podium: 'Podium',
      active: 'Les plus actifs',
      streak: 'Régularité',
      progress: 'En progrès',
      explorer: 'Explorateurs',
      unit: {
        active_one: '{{count}} plongeon', active_other: '{{count}} plongeons',
        streak_one: '{{count}} semaine', streak_other: '{{count}} semaines',
        progress: '{{value}} de médiane',
        explorer_one: '{{count}} code', explorer_other: '{{count}} codes',
      },
      empty: {
        active: 'Personne n’a plongé sur cette période.',
        streak: 'Aucune série de semaines en cours.',
        progress: 'Pas assez d’essais notés pour comparer.',
        explorer: 'Aucun code sur cette période.',
      },
    },
    sharedDives_one: '{{count}} plongeon partagé',
    sharedDives_other: '{{count}} plongeons partagés',
    noSharedDives: 'Aucun plongeon partagé',
    latestDive: 'Dernier plongeon',

    "title": "Communauté",
    "myProfile": "Mon profil",
    "search": "Rechercher un nom ou @pseudo",
    "error": "Impossible de charger les membres.",
    "empty": "Aucun membre ne correspond à votre recherche.",
    "more": "Voir plus de membres",
    remaining_one: 'Afficher le membre restant ({{count}})',
    remaining_other: 'Afficher les {{count}} membres restants',
    "back": "Communauté",
    "edit": "Modifier le profil",
    "name": "Nom affiché",
    "handle": "Pseudo",
    "handleHint": "Facultatif. 3 à 30 lettres, chiffres ou tirets bas. Chaque pseudo est unique.",
    "bio": "Bio",
    "avatar": "Photo de profil",
    "avatarHint": "JPEG, PNG ou WebP · 2 Mo et 16 mégapixels maximum. La photo est enregistrée immédiatement.",
    "removeAvatar": "Supprimer la photo",
    "avatarInvalid": "Utilisez une image JPEG, PNG ou WebP de 2 Mo et 16 mégapixels maximum.",
    "saveError": "Impossible d’enregistrer votre profil. Réessayez.",
    "handleTaken": "Ce pseudo est déjà utilisé. Choisissez-en un autre.",
    "dives": "Plongeons",
    "activity": "Activité",
    "achievements": "Succès",
    "profileSections": "Sections du profil",
    "latest": "Les plus récents en premier · seuls les plongeons accessibles sont affichés.",
    "openDive": "Voir {{code}} · {{height}}",
    "privateDive": "Plongeon privé",
    "divesError": "Impossible de charger ces plongeons.",
    "noDives": "Aucun plongeon à afficher pour le moment.",
    "moreDives": "Voir plus de plongeons"
},
  profile: {
    ago: { hours: 'h', days: 'j', months_one: 'mois', months_other: 'mois', years_one: 'an', years_other: 'ans' },
    stats: 'Statistiques',
    kpi: { dives: 'Plongeons', codes: 'Codes', sessions: 'Séances', last: 'Dernier' },
    weeksAria: 'Plongeons par semaine sur {{count}} semaines',
    thisWeek: 'cette semaine',
    breadcrumb: 'Profil du membre',
    memberSince: 'Membre depuis {{date}}',
    diverOf: 'Plongeur :',
    emptyActivity: 'Aucune activité à afficher pour le moment.',
    errorLoad: 'Profil du membre indisponible.',
    notFoundTitle: 'Membre introuvable',
    today: 'Aujourd’hui',
    yesterday: 'Hier',
    trail: {
      dive_like: 'a aimé le plongeon',
      comment: 'a commenté le plongeon',
      comment_like: 'a aimé un commentaire sur le plongeon',
    },
  },
  settings: {
    language: 'Langue',
    languageDesc:
      'S’applique immédiatement. Les noms de plongeons suivent la terminologie française de World Aquatics (FFN).',
    languageSystemOption: 'Comme l’appareil',
    languageChanged: 'Langue mise à jour.',
  },
  dashboard: {
    title: 'Tableau de bord d’entraînement',
    errorLoad: 'Échec du chargement des données du tableau de bord',
    lastUpdated: 'Dernière mise à jour',
    syncProgress: 'Synchro',
    totalDives: 'Plongeons au total',
    successRate: 'Taux de réussite',
    successRateSubtitle: 'Moyen ou mieux',
    avgPerformance: 'Performance moy.',
    avgPerformanceSubtitle: 'Calibrée /10',
    avgDD: 'Cotation moy.',
    maxDD: 'Cotation max',
    trainingSessions: 'Séances d’entraînement',
    personalDiveValue: 'Valeur de plongeon personnelle',
    highestRecent: 'plus élevée récente',
    latestEligibleAttempts: 'derniers plongeons admissibles',
    personalValueHistoryAria: 'Historique récent de la valeur de plongeon personnelle',
    monthlyProgression: 'Progression mensuelle',
    performanceByHeight: 'Performance par hauteur',
    byDirection: 'Par groupe de plongeon',
    successRateTrend: 'Tendance du taux de réussite',
    trainingFocus: 'Axes d’entraînement',
    dives: 'Plongeons',
    recentSessions: 'Séances d’entraînement récentes',
    viewAll: 'Tout voir →',
    dirFallback: 'Groupe',
    date: 'Date',
    personal: 'Personnels',
    averagePerformance: 'Performance moyenne',
  },
  jargon: {
    springboard: 'tremplin',
    platform: 'plateforme',
    unknownPosition: 'Position inconnue',
    positions: { A: 'Droit', B: 'Carpé', C: 'Groupé', D: 'Libre' },
    phaseN: 'Phase {{n}}',
    heights: {
      '1m': '1 m',
      '3m': '3 m',
      '5m': '5 m',
      '7m': '7,5 m',
      '7.5m': '7,5 m',
      '10m': '10 m',
    },
    phase1: 'Impulsion + vol',
    phase2: 'Ouverture + entrée',
  },
  groups: {
    1: 'Avant',
    2: 'Arrière',
    3: 'Renversé',
    4: 'Retourné',
    5: 'Vrille',
  },
  performance: {
    P: 'Parfait',
    G: 'Bon',
    M: 'Moyen',
    B: 'Sous la cible',
    F: 'Manqué',
  },
  attemptDetail: {
    score: 'Score',
    diver: 'Plongeur',
    officialDD: 'Cotation officielle',
    notDefined: 'Non définie',
    phases: 'Phases',
    singleRating: 'Note unique',
    height: 'Hauteur',
    platform: 'Plateau',
    media: 'Média',
    rawCaption: 'Légende d’origine',
    noCaption: 'Aucune légende conservée.',
    notPreserved: 'Non conservée',
    notes: 'Notes',
  },
  dives: {
    openCodeAttempt: 'Ouvrir le plongeon {{code}}',
    openLatestAttempt: 'Ouvrir le dernier plongeon {{code}}',
    avg: 'moy.',
    best: 'meilleur',
    last: 'dernier',
    attemptsCount: '{{count}} plongeons',
    recentAttemptsFor: 'Plongeons récents {{code}}',
    openAttemptFrom: 'Ouvrir le plongeon {{code}} du {{date}}',
    openAttemptAria: 'Ouvrir le plongeon {{code}} {{date}}',
    score: 'Score',
    errorSaved: 'Affichage des plongeons enregistrés. Impossible d’actualiser la bibliothèque.',
    errorLoad: 'Impossible de charger la bibliothèque de plongeons.',
    attempts: 'plongeons',
    codes: 'codes',
    refresh: 'Actualiser la bibliothèque',
    viewClips: 'Extraits',
    viewByCode: 'Par code',
    filtersAria: 'Filtres de la bibliothèque de plongeons',
    myDives: 'Mes plongeons',
    community: 'Communauté',
    searchPlaceholder: 'Rechercher un plongeon…',
    searchAria: 'Rechercher des plongeons',
    filters: 'Filtres',
    gridView: 'Vue grille',
    listView: 'Vue liste',
    codeView: 'Vue par code',
    heightFilter: 'Hauteur',
    allHeights: 'Toutes les hauteurs',
    heightsPartial: 'D’autres hauteurs existent (la liste est partielle).',
    heightsPartialAria: 'La liste des hauteurs est partielle : d’autres hauteurs existent au-delà de cette vue bornée. Ouvrez les filtres de la Library pour les charger en paginant.',
    contextFilter: 'Contexte',
    contextAll: 'Individuel + SYNCHRO',
    contextIndividual: 'Individuel seulement',
    contextSync: 'SYNCHRO seulement',
    ratingFilter: 'Note',
    allRatings: 'Toutes les notes',
    scoreChipTitle: '{{score}} sur l’échelle 0–10 — lettre affichée {{letter}} (P · Parfait … F · Échec).',
    modifierHelp: 'Que signifient DB, SD, HU, SYNC et DD ?',
    modifierNames: { DB: 'Double rebond', SD: 'Départ sans élan', HU: 'Mains en haut' },
    modifierDescriptions: {
      DB: 'Deux rebonds sur le tremplin à la place d’un pas d’appel complet.',
      SD: 'Départ sur place, sans pas d’appel, pour les plongeons avant ou renversés.',
      HU: 'Mains maintenues en haut pendant tout le pas d’appel.',
    },
    helpSyncName: 'Synchronisé',
    helpSyncDescription: 'Le plongeon fait partie d’une paire synchronisée — deux plongeuses ou plongeurs qui s’alignent, souvent d’une séance partagée.',
    helpDdName: 'Valeur de difficulté (table World Aquatics)',
    helpDdDescription: 'La DD pondère le code, la hauteur et la position. Les notes vont sur l’échelle séparée 0–10.',
    ratingsItem: 'Lettres de note',
    ratingsScale: 'P · Parfait 10 — G · Bien 7 — M · Moyen 4,5 — B · Sous la cible 2 — F · Échec 0.',
    modifiers: 'Modificateurs',
    resetFilters: 'Réinitialiser les filtres',
    noMatches: 'Aucun plongeon ne correspond à cette recherche.',
    clearFilters: 'Tout effacer',
    loadMore: 'Charger plus de plongeons',
    showMoreAttempts: 'Afficher 48 plongeons de plus',
    openingVideo: 'Ouverture de la vidéo…',
  },
  codeAnalysis: {
    progressTab: 'Progrès',
    sortAria: 'Trier les codes',
    sort: { recent: 'Récents', volume: 'Plus travaillés', progress: 'En progrès' },
    openCode: 'Analyser {{code}}',
    median: 'médiane',
    average: 'moyenne',
    success: 'réussite',
    summary: 'Résumé du code',
    attemptsSessions: '{{attempts}} plongeons · {{sessions}} séances',
    attemptsShort: '{{count}} pl.',
    stable: 'Stable',
    trendTooOld: 'Pas assez récent',
    sinceLastAttempt: 'depuis le dernier essai',
    rising: 'Ça monte',
    falling: 'Ça baisse',
    sixWeeks: '6 dernières sem.',
    periodAria: 'Période',
    period: { '1m': '1 mois', '3m': '3 mois', '1y': '1 an', all: 'Tout' },
    sample: '{{attempts}} plongeons · {{sessions}} séances · {{from}} → {{to}}',
    sampleCapped: '{{attempts}} plongeons affichés (sur {{total}}) · {{sessions}} séances · {{from}} → {{to}}',
    cappedAria: 'Historique plafonné aux {{total}} derniers plongeons de ce code.',
    cappedPlain: 'Historique plafonné à la fenêtre des plongeons les plus récents pour cette vue.',
    successTitle: 'Part des plongeons notés à G (7/10) ou mieux.',
    rankTitle: 'Classement par score parmi les {{total}} plongeons de ce code ; les ex æquo partagent le rang.',
    thisDive: 'Ce plongeon',
    rankFirst: '1er sur {{total}}',
    rankOf: '{{rank}}ᵉ sur {{total}}',
    vsMedian: 'vs votre médiane',
    vsPreviousDive: 'vs précédent ({{score}})',
    record: 'record',
    bestSince: 'meilleur depuis {{count}} sem.',
    scores: 'Scores',
    chartModeAria: 'Affichage du graphique',
    modeAttempts: 'Plongeons',
    modeSessions: 'Séances',
    chartLabel: 'Scores des {{count}} points de {{code}}',
    chartKeys: 'Touchez ou glissez pour parcourir ; flèches gauche et droite au clavier.',
    legendMedian: 'médiane glissante',
    legendRange: 'zone habituelle',
    peak: 'pic',
    valley: 'creux',
    peakExplain: 'Pic · médiane {{median}} sur {{count}} plongeons ({{from}} → {{to}}). Voici le meilleur de cette période.',
    valleyExplain: 'Creux · médiane {{median}} sur {{count}} plongeons ({{from}} → {{to}}). Voici le plus faible de cette période.',
    watch: 'Voir',
    context: 'Selon le contexte',
    phase: 'Phase {{n}}',
    phase1Costs: 'La phase 1 coûte des points.',
    phase2Costs: 'La phase 2 coûte des points.',
    phasesEven: 'Les deux phases se valent.',
    sessions: 'Séances',
    allSessions: 'Voir les {{count}} séances',
    fewerSessions: 'Réduire',
    representatives: 'Représentants',
    rep: { best: 'Meilleur', latest: 'Plus récent', typical: 'Médian', review: 'À revoir' },
    related: 'Codes liés',
    community: {
      title: 'Communauté',
      legend: 'médiane · moitié centrale',
      you: 'Vous',
      others: 'Les autres',
      ranking: 'Classement',
      compareWith: 'Comparer avec {{name}}, médiane {{median}}',
      vsYou: 'contre {{score}} pour vous',
      chartLabel: 'Médiane glissante sur les 40 derniers essais : vous, {{name}} et les autres plongeurs',
      best: 'Meilleur',
      fullAnalysis: 'Analyse complète',
      profile: 'Profil',
      hidden_one: '+{{count}} plongeur avec moins de 3 essais notés',
      hidden_other: '+{{count}} plongeurs avec moins de 3 essais notés',
      backToMine: 'Mon analyse',
    },
    relation: { position: 'autre position', twists: 'plus ou moins de vrilles', noTwist: 'sans vrille', group: 'même groupe' },
    details: 'Analyse détaillée',
    straightJump: 'Les sauts droits ne sont pas notés : seules les vidéos sont disponibles.',
    emptyPeriod: 'Aucun {{code}} sur cette période.',
    showAll: 'Tout afficher',
    loadError: 'Impossible de charger ce code.',
    kpi: { attempts30: 'Plongeons · 30 j', sessions30: 'Séances · 30 j', codes30: 'Codes travaillés · 30 j', median30: 'Médiane · 30 j' },
    vsPrevious30: 'vs les 30 j d’avant',
    nothingClear: 'Rien de net',
    resume: 'À reprendre',
    resumeHint: 'pas fait depuis {{days}} j',
    allCurrent: 'Tout est à jour',
    heatTitle: 'Codes × mois',
    heatHint: 'médiane',
    heatCell: '{{code}} · {{month}} · {{count}} pl. · médiane {{median}}',
    volume: 'Volume par semaine',
    weeks: '{{count}} semaines',
    weekOf: 'semaine du {{date}} · {{count}} pl.',
    emptyWeek: 'Pas de plongeon cette semaine',
  },
  analysis: {
    sample: {
      noData: 'Aucune donnée',
      insufficient: 'Insuffisant',
      exploratory: 'Exploratoire',
      moderateSample: 'Échantillon modéré',
      strongerSample: 'Échantillon descriptif plus solide',
    },
    trendDirection: {
      improving: 'en progrès',
      declining: 'en recul',
      stable: 'stable',
      insufficient_data: 'données insuffisantes',
      plateauing: 'en stagnation',
      struggling: 'en difficulté',
    },
    dimension: {
      modifier: 'modificateur',
      height: 'hauteur',
      position: 'position',
      sync: 'SYNCHRO',
      diver: 'plongeur',
      training_period: 'période d’entraînement',
    },
    previousUnavailable: 'Précédent indisponible',
    noChange: 'Aucun changement',
    vsPrevious: 'vs précédent',
    pointLabel: '{{date}}, score {{score}}, {{height}}, {{position}}, {{modifiers}}, {{context}}, média {{media}}',
    sessionLabel: '{{date}}, séance {{session}}, plage {{min}} à {{max}}, médiane {{median}}, {{attempts}} plongeons',
    periodLabel: '{{start}} à {{end}}, plage {{min}} à {{max}}, médiane {{median}}, {{attempts}} plongeons',
    combined: 'Combiné',
    noModifier: 'Aucun modificateur',
    individual: 'Individuel',
    noModifiers: 'Aucun modificateur',
    unassigned: 'Non attribué',
    none: 'Aucun',
    any: 'Tous',
    first: 'premier',
    latest: 'dernier',
    in: 'dans',
    emerging: 'émergent',
    attempts: 'plongeons',
    attemptsToReview: 'Plongeons à revoir',
    sessionsLabel: 'séances',
    cachedClips: 'extraits en cache',
    thisAttempt: 'Ce plongeon',
    attemptNotInScope: 'L’extrait lié ne fait pas partie de cette vue d’analyse. Affichage de tous les plongeons {{code}}.',
    diveCode: 'Code du plongeon',
    analyze: 'Analyser',
    execution: 'exécution',
    score: 'score',
    position: 'Position',
    positions: 'Positions',
    heights: 'Hauteurs',
    context: 'Contexte',
    modifiers: 'Modificateurs',
    modifier: 'Modificateur',
    modifierMatch: 'Correspondance des modificateurs',
    modifierAny: 'Au moins un sélectionné',
    modifierAll: 'Tous les sélectionnés',
    diver: 'Plongeur',
    diverScope: 'Champ du plongeur',
    allDivers: 'Tous les plongeurs',
    selectedDivers: 'Plongeurs sélectionnés',
    selectedDiversCount: '{{count}} plongeurs sélectionnés',
    primary: 'principal',
    trainingPeriod: 'Période d’entraînement',
    trainingPeriods: 'Périodes d’entraînement',
    allPeriods: 'Toutes les périodes',
    dateFrom: 'Du',
    dateTo: 'Au',
    dateRange: '{{from}} à {{to}}',
    aggregateScope: '{{code}} · {{scope}} · {{attempts}} plongeons · filtres courants',
    filters: 'Filtres',
    view: 'Affichage',
    chartView: 'Vue du graphique',
    sessionSummary: 'Synthèse par séance',
    performanceRange: 'Plage de performance',
    allAttempts: 'Tous les plongeons',
    splitBy: 'Répartir par',
    splitByHeight: 'Répartir par hauteur',
    splitByPosition: 'Répartir par position',
    byAttempts: 'Par plongeon',
    bySessionMedians: 'Par médianes de séance',
    weighting: 'Pondération',
    weightingHint: 'La pondération par plongeon donne la même influence à chaque répétition. La pondération par séance donne la même influence à chaque médiane de séance.',
    resetAll: 'Réinitialiser tout',
    copyLink: 'Copier le lien',
    last3Months: '3 derniers mois',
    last6Months: '6 derniers mois',
    progression: 'Progression',
    rangeByPeriod: 'Plage de performance par période',
    scoreProgression: 'Progression des scores dans le temps',
    scoresRange: 'Les scores varient de {{min}} à {{max}}, médiane {{median}}, avec un écart {{spread}} sur {{attempts}} plongeons.',
    spreadWide: 'large',
    spreadModerate: 'modéré',
    chartLegend: 'Légende du graphique',
    legendMax: 'Max',
    legendMedian: 'Médiane',
    legendMin: 'Min',
    legendRangeHint: 'Une plage verticale par période adaptative · sélectionnez une médiane pour ouvrir un plongeon précis',
    legendIndividual: 'Plongeon individuel',
    legendSync: 'Plongeon SYNCHRO',
    legendRolling: 'Médiane glissante sur 5 plongeons',
    legendReady: 'Contour = vidéo prête',
    noScoredAttempts: 'Aucun plongeon noté n’est disponible pour cette série.',
    scoreDistribution: 'Répartition des scores',
    contextBreakdown: 'Répartition par contexte',
    equivalentOnly: 'Contextes équivalents seulement',
    mixedContext: 'Contexte de comparaison mixte',
    equivalentContext: 'Contexte équivalent',
    sampleHeading: 'Échantillon',
    allPositions: 'Toutes les positions',
    reviewBest: 'Revoir le meilleur plongeon ({{score}})',
    ddCoverage: 'Couverture de cotation',
    threshold: 'seuil',
    coverage: 'couverture',
    difficulty: 'Cotation',
    comparisonHistory: 'Comparaison et historique',
    periodComparison: 'Comparaison par période',
    pickDateRange: 'Choisissez une plage de dates à comparer avec la période précédente.',
    measure: 'Mesure',
    selectedPeriod: 'Période sélectionnée',
    previousPeriod: 'Période précédente équivalente',
    change: 'Changement',
    selected: 'Sélectionné',
    previous: 'Précédent',
    median: 'Médiane',
    average: 'Moyenne',
    averageExecution: 'Exécution moyenne',
    medianExecution: 'Exécution médiane',
    avg: 'moy.',
    iqr: 'IQR',
    success: 'Réussite',
    points: 'pts',
    consistency: 'Régularité',
    highVariability: 'Variabilité élevée',
    tighterSpread: 'Dispersion serrée',
    trend: 'Tendance',
    whatChanged: 'Changements',
    keySummary: 'Synthèse clé',
    selectedAttempt: 'Plongeon sélectionné',
    openAttemptDetails: 'Ouvrir les détails du plongeon',
    phaseAnalysis: 'Analyse par phase',
    phaseScores: 'Scores de phase',
    rating: 'Note',
    backToClip: 'Retour à l’extrait',
    weightingAria: 'Pondération de l’analyse',
    splitByAria: 'Répartition de la progression',
    phaseChartView: 'Vue du graphique de phase',
    repAttempts: 'Plongeons représentatifs',
    noAttemptsInView: 'Aucun plongeon dans cette vue.',
    noAttemptsMatch: 'Aucun plongeon {{code}} ne correspond aux filtres.',
    totalAttempts: 'plongeons au total',
    scored: 'notés',
    missing: 'manquants',
    noAttemptsWithFilters: 'Aucun plongeon ne correspond à ces filtres.',
    closeAttempt: 'Fermer les détails du plongeon',
    mediaFor: 'Média du plongeon {{code}} {{id}}',
    noLinkedAsset: 'Aucun média Photos lié',
    sessionN: 'Séance {{id}}',
    recent5Median: 'Médiane des 5 derniers',
    fromRolling: 'Par rapport à la médiane glissante',
    openPrevious: 'Ouvrir le plongeon précédent',
    openNext: 'Ouvrir le plongeon suivant',
    next: 'Suivant',
    openSession: 'Ouvrir la séance',
    personalReviewPriority: 'Priorité de révision personnelle',
    pdvHistoryAlt: 'Historique de la valeur de plongeon personnelle pour {{count}} plongeons. Valeurs de {{min}} à {{max}}.',
    pdvPoint: '{{date}} : valeur de plongeon personnelle {{value}}, {{signal}}',
    pdvScale: 'Valeur de plongeon personnelle / 100',
    pdvNotable: 'Plongeons notables (valeur personnelle)',
    mostNotable: 'Le plus notable dans cette vue',
    historicalSignal: 'Signal historique',
    representatives: 'Plongeons représentatifs',
    openRepGallery: 'Ouvrir la galerie des représentants',
    noTypicalRep: 'Aucun représentant typique sélectionné.',
    noBandRep: 'Aucun représentant {{band}} sélectionné.',
    noPoster: 'Affiche non prête',
    play: 'Lire',
    openAttempt: 'Ouvrir le plongeon',
    findReplacement: 'Trouver un remplaçant',
  },
  // ---- Ajouts des corrections UX (2026-11, fiabilité des retours) ------
  routeError: {
    title: 'Impossible d’ouvrir cette page.',
    body: 'Le chargement de l’app s’est interrompu. Rechargez pour réessayer.',
    reload: 'Recharger',
  },
} as const

export default fr
